import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Note, PrivateLesson, PrivateLessonsDataTable } from '../../models/types';
import { PricePipe } from '@lx/shared/ui/pipes';
import { TableModule } from 'primeng/table';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { Currency } from '../../models/currency.model';
import { NotesComponent } from '../notes/notes.component';
import { NotesService } from '../../services/notes.service';
import { SubjectEnum } from '../../utils/notes.utils';
import { PriceListNote } from '../../models/priceslist-note.model';
import { Company, CompanyEnum } from '../../models/company.model';
import { YoungAdultsPrivateLessons } from '../../models';

@Component({
  standalone: true,
  imports: [CommonModule, PricePipe, TableModule, TableHeaderComponent, NotesComponent],
  selector: 'lx-price-lists-portal-young-adults-private-lessons-table',
  templateUrl: './young-adults-private-lessons-table.component.html',
  styleUrls: ['./young-adults-private-lessons-table.component.scss'],
})
export class YoungAdultsPrivateLessonsTableComponent implements OnInit {
  @Input() company: Company = CompanyEnum.KIL;
  @Input() currency: Currency | undefined;
  @Input() privateLessons: PrivateLesson[] | YoungAdultsPrivateLessons[] = [];
  @Input() privateLessonsNotes: PriceListNote[] | undefined;

  protected notes: Note[] | undefined;
  protected notationMarks: Record<string, string> | undefined;
  protected privateLessonsDataSource: PrivateLessonsDataTable[] = [];
  protected privateLessonsTableLabels = [];

  private readonly notesService = inject(NotesService);

  ngOnInit(): void {
    const privateLessons = this.notesService.getNotes(this.privateLessonsNotes, SubjectEnum.PRIVATE_LESSONS);
    if (privateLessons) {
      [this.notes, this.notationMarks] = privateLessons;
    }

    this.privateLessons?.forEach(({ name, lessons }) => {
      this.privateLessonsTableLabels.push(name);
      lessons?.forEach(({ name, price }) => {
        const pricesForGroup = this.privateLessonsDataSource?.find(({ numberOfLessons }) => numberOfLessons === name);
        if (!pricesForGroup) {
          this.privateLessonsDataSource.push(<PrivateLessonsDataTable>{
            numberOfLessons: name,
            prices: [price],
          });
        } else {
          pricesForGroup.prices = [...pricesForGroup.prices, price];
        }
      });
    });
  }
}
